<a href (click)="onClick($event)" class="text-nowrap">
  @if (sort) {
    <i class="bi me-2" [ngClass]="{'bi-sort-down':sort==='asc','bi-sort-up':sort==='desc'}"></i>
  }
  <span [innerHTML]="content"></span>
</a>
